import gql from 'graphql-tag';

export default gql`
  mutation deleteWorkflow($workflowId: ID!) {
    deleteWorkflow(workflowId: $workflowId)
  }
`;
